import L from 'leaflet';
import ReactDOMServer from 'react-dom/server';

import {
    ENDPOINT_DATA_GEOSERVICIOS,
    GIS_CLUSTERING_ZOOM_THRESHOLD,
    GIS_LIGHTNING_ICON_RADIUS_PIXELS,
    //REALTIME_INTERVAL_SECONDS,
    REALTIME_INTERVAL_SECONDS_U,
} from '../../../constants';
import LightningsIcon from '../icons/LightningsIcon';
import LightningTooltip from '../tooltips/LightningTooltip';

import 'leaflet-realtime';
import 'leaflet.markercluster';

import 'leaflet.markercluster/dist/MarkerCluster.css';

/**
 * @param {number} idCliente - Client id for the request.
 * @param {string} ptws - tws a mostrar en mapa
 * @returns Array of two elements: LINET lightnings markerclustergroup and LINET lightnings realtime reference, the
 * reference needs to be returned to stop the subscription later.
 */
const getLineLightningsMarkerClusterGroupRealtime=(idCliente,ptws,colorLine)=>{
    const lineLightningsMarkerClusterGroup = createLineLightningsMarkerClusterGroup();
    const realtimeReference = L.realtime(
        {
            url: ENDPOINT_DATA_GEOSERVICIOS,
            method: 'POST',
            body: JSON.stringify({
                solicitud: 'LINET',
                idCliente,
                ptws,
            }),
        },
        {
            container: lineLightningsMarkerClusterGroup,
            interval: REALTIME_INTERVAL_SECONDS_U * 1000,
            onEachFeature: (feature, layer) => {
                layer.bindTooltip(
                    ReactDOMServer.renderToString(
                        <LightningTooltip coordinates={feature.geometry.coordinates} {...feature.properties} />
                    ),
                    { direction: 'top' }
                );
            },
            pointToLayer: (feature, latlng) => {
                return L.circleMarker(latlng, {
                    fillColor: getLineLightningColor(feature.properties.difmin,colorLine),
                    fillOpacity: 1,
                    pmIgnore: true,
                    radius: GIS_LIGHTNING_ICON_RADIUS_PIXELS,
                    stroke: false,
                });
            },
            removeMissing: true,
            updateFeature: (feature, oldLayer, newLayer) => newLayer,
        }
    );
    return [lineLightningsMarkerClusterGroup, realtimeReference];
}

/**
 * @returns LINET lightnings markerclustergroup.
 */
const createLineLightningsMarkerClusterGroup = () => {
    return L.markerClusterGroup({
        chunkedLoading: true,
        disableClusteringAtZoom: GIS_CLUSTERING_ZOOM_THRESHOLD,
        iconCreateFunction: (cluster) =>
            L.divIcon({
                className: '',
                html: ReactDOMServer.renderToString(<LightningsIcon childCount={cluster.getChildCount()} />),
                iconSize: [35, 35],
            }),
        spiderfyOnMaxZoom: false,
    });
};


/**
 * @param {*} difmin - Property "difmin", the LINET lightning color depends on this property.
 * @returns LINET lightning color, based on "difmin" property.
 */
const getLineLightningColor = (difmin,color) => {
    const colorSelector = color[0].split(',')
    
    if (difmin < 1) {
        return colorSelector[0];
    } else if (difmin < 5) {
        return colorSelector[1];
    } else if (difmin < 10) {
        return colorSelector[2];
    } else if (difmin < 20) {
        return colorSelector[3];
    } else if (difmin < 30) {
        return colorSelector[4];
    } else if (difmin < 40) {
        return colorSelector[5];
    } else if (difmin < 50) {
        return colorSelector[6];
    } else {
        return colorSelector[7];
    }
};

export {getLineLightningsMarkerClusterGroupRealtime};